import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonPrimary, ButtonSecondary, When, colors, HSpacer, LoadingDot, ErrorModal, Ticket, ticketType } from '@aftersale-next/ui';
import { Heading, Text } from '@chakra-ui/react';
import { useState } from 'react';
import * as retentionActions from '../../config/constants/retention-actions';
export function RetentionWithBonus(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(''),
      selectedAction = _useState[0],
      setSelectedAction = _useState[1];

  var handleClick = function handleClick(action) {
    props.onConfirm(action);
    setSelectedAction(action);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(When, {
      value: !props.isError,
      children: [/*#__PURE__*/_jsx(Ticket, {
        type: ticketType.TICKET_VOUCHER,
        value: props.totalPackageValue
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "24px"
      }), /*#__PURE__*/_jsx(Heading, {
        fontSize: "sm",
        textAlign: "center",
        textTransform: "uppercase",
        children: t('RETENTION_WITH_BONUS_TITLE')
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "24px"
      }), /*#__PURE__*/_jsx(Text, {
        align: "center",
        children: t('RETENTION_WITH_BONUS_DESCRIPTION')
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "32px"
      }), /*#__PURE__*/_jsxs(ButtonPrimary, {
        "data-testid": "retention_accept",
        bgColor: colors.green,
        disabled: props.isLoading,
        onClick: function onClick() {
          return handleClick(retentionActions.ACCEPT_RETENTION_WITH_BONUS);
        },
        children: [/*#__PURE__*/_jsx(When, {
          value: selectedAction !== retentionActions.ACCEPT_RETENTION_WITH_BONUS,
          children: t('ACTION_ACCEPT_RETENTION_WITH_BONUS')
        }), /*#__PURE__*/_jsx(When, {
          value: props.isLoading && selectedAction === retentionActions.ACCEPT_RETENTION_WITH_BONUS,
          children: /*#__PURE__*/_jsx(LoadingDot, {})
        })]
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "8px"
      }), /*#__PURE__*/_jsxs(ButtonSecondary, {
        "data-testid": "retention_refuse",
        id: "refuse_retention_modal",
        disabled: props.isLoading,
        bgColor: "none",
        borderColor: colors.green,
        textColor: colors.green,
        onClick: function onClick() {
          return handleClick(retentionActions.REFUSE_RETENTION);
        },
        children: [/*#__PURE__*/_jsx(When, {
          value: selectedAction !== retentionActions.REFUSE_RETENTION,
          children: t('ACTION_REFUSE_RETENTION')
        }), /*#__PURE__*/_jsx(When, {
          value: props.isLoading && selectedAction === retentionActions.REFUSE_RETENTION,
          children: /*#__PURE__*/_jsx(LoadingDot, {
            color: colors.green
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(When, {
      value: props.isError,
      children: /*#__PURE__*/_jsx(ErrorModal, {
        isLoading: props.isLoading,
        isError: props.isError,
        onClose: props.onClose,
        selectedAction: selectedAction,
        onConfirm: handleClick
      })
    })]
  });
}
export default RetentionWithBonus;